import { Yup } from 'shared/lib'

const validPostCode = /^(?:[A-Za-z]{2})?(?:\d{4}|\d{5}|\d{6}|\d{2}-\d{3}|\d{3}\s?\d{2})$/

const validCity =
   /^([a-zA-ZżźćńółęąśŻŹŚŁĆŃÓĘĄäÄöÖüÜßẞÁČĎÉĚèàìòùçChÍŇÓŘŠŤÚŮÝŽáčďéěèàìòùçchíňóřštúůýž'-]\s?)*([^\s\d][a-zA-ZżźćńółęąśŻŹŚŁĆŃÓĘĄäÄöÖüÜßẞÁČĎÉĚèàìòùçChÍŇÓŘŠŤÚŮÝŽáčďéěèàìòùçchíňóřštúůýž])$/

export const addressSchema = Yup.object().shape({
   street: Yup.string().max(100),
   houseNumber: Yup.string().max(15),
   zipCode: Yup.string().matches(validPostCode, 'validation.postCodePattern'),
   city: Yup.string().matches(validCity, 'validation.cityPattern'),
   country: Yup.string(),
   deliveryType: Yup.string().oneOf(['PICK_UP', 'ADDRESS']),
   extraComments: Yup.string().optional().nullable().max(300),
})
